import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Dropdown from "../../../reusables/dropdown";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../../utils/pageTransitions";
import InputField from "../../../reusables/input";
import { get_customer_payments, get_supplier_payments } from "../../../../redux/actions/adminActions";
import { connect } from "react-redux";
import { order_payment_status, periods, user_transaction_status } from "../../../../utils/options";
import Spinner from "../../../reusables/spinner";
import Pagination from "../../../reusables/pagination";
import ConfirmModal from "../../../modals/confirmModal";

function Payments({ accessToken, getPayments, supplier_payments, selected }) {
  const [loading, setLoading] = useState(true);
  const [optionsActive, setOptions] = useState(null);
  const [payments, setPayments] = useState(supplier_payments);
  const [payment, setPayment] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState({});
  const [confirm, setConfirm] = useState({
    modal: false,
    data: [],
    payment: 0,
    status: "unpaid",
  });
  const token = accessToken;
  let params = {};

  useEffect(() => {
    getPayments({ token, selected, success });
  }, [selected]);

  useEffect(() => {
    setPayments(supplier_payments);
  }, [supplier_payments]);

  const success = () => {
    setLoading(false);
  };

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    setTime(Item);
    let filter = Item;
    setLoading(true);
    params = { ...params, ...{ filter: Item } };
    getPayments({ token, selected, success, params });
  };

  const [hasFilter, setFilter] = useState(false);
  const [selectedStatus, setStatus] = useState("Status");
  const handleFilter = (status) => {
    setStatus(status);
    params = { ...params, ...{ status: status } };
    getPayments({ token, selected, success, params });
  };

  const onPageChange = (page) => {
    setLoading(true);
    params = { ...params, ...{ page: page } };
    getPayments({ token, selected, success, params });
  };

  const handleSearch = (e) => {
    setLoading(true);
    let value = e.target.value;
    params = { ...params, ...{ search: value } };
    getPayments({ token, selected, success, params });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween">
          <div className="searchHolder">
            <InputField
              placeholder="Search by name, phone number or email"
              icon
              iconClass="ri-search-line"
              onChange={handleSearch}
            />
          </div>

          <div className="alignOnly pt-2">
            <Dropdown value={selectedTime} className="mx-1">
              {periods?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleSelectTime(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
            <Dropdown value={selectedStatus} className="mx-1">
              <div
                className="isClickable hoverGreen"
                onClick={() => {
                  setStatus("All");
                  setFilter(false);
                }}
              >
                <p className="sectionText px-3 py-2 mb-0">All</p>
              </div>
              {user_transaction_status?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleFilter(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
          </div>
        </div>

        {loading ? (
          <Spinner big />
        ) : (
          <div className="sectionHeight--mid scrollable--mobile pt-4">
            {payments?.data?.length > 0 ? (
              <table className="table table__custom">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Order Number</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">Total Products Cost</th>
                    <th className="vAlign">Total Handling Cost</th>
                    <th className="vAlign">Delivery Cost</th>
                    <th className="vAlign">Sub Total</th>
                    <th className="vAlign">Exch. Rate</th>
                    <th className="vAlign">Status</th>
                    <th className="vAlign">Action</th>
                  </tr>
                </thead>
                <tbody className="">
                  {payments?.data?.map((order) => (
                    <tr className="hasRadius">
                      <td className="alignOnly pt-3">
                        <input
                          type="checkbox"
                          className="isClickable"
                          name=""
                          id=""
                        />

                        <p className="mb-0  sectionText mx-2">
                          #{order.sub_order_id}
                        </p>
                      </td>

                      <td className="pt-3 vAlign">
                        <p className="mb-0  sectionText">{order.date}</p>
                      </td>

                      <td className="pt-3 vAlign">
                        <p className="mb-0  sectionText">
                          ₦{order.product_cost}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <p className="mb-0 sectionText">
                          ₦{order.handling_cost}
                        </p>
                      </td>

                      <td className="vAlign pt-3 address">
                        <p className="mb-0 sectionText">
                          ₦{order.delivery_cost}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <p className="mb-0  sectionText">₦{order.sub_total}</p>
                      </td>

                      <td className="vAlign pt-3">
                        <p className="mb-0  sectionText">
                          ₦{order.exchange_rate}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <p
                          className={`mb-0  tag ${
                            order.order_item.order.transaction.status == "success" ? "done" : "failed"
                          }`}
                        >
                          {order.order_item.order.transaction.status == "success" ? order.order_item.order.transaction.status : "failed"}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <i
                          class="ri-more-line isClickable"
                          onClick={
                            optionsActive === order.id
                              ? () => setOptions(null)
                              : () => setOptions(order.id)
                          }
                        ></i>

                        {optionsActive === order.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                              <div
                                className="hasBorder--bottom pb-2"
                                onClick={() => {
                                  setSelectedPayment(order)
                                  setPayment(true)
                                }}
                              >
                                View
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 center sectionHeight--mid pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No payment yet
                </h2>
              </div>
            )}
          </div>
        )}
        <div className="d-flex justify-content-end">
          <Pagination
            onChange={onPageChange}
            page={payments?.current_page}
            total={payments?.total}
            per_page={payments?.per_page}
          />
        </div>
      </div>

      <Modal show={payment} onHide={() => setPayment(false)} centered>
        <div className="sectionHeight--mid sectionText p-3">
          <div className="hasBorder--bottom">
            {/* <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Status</p>

              <div className="tag done">Paid</div>
            </div> */}

            {/* {{ selectedPayment }} */}

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Order ID</p>

              <p className="mb-0">{selectedPayment.sub_order_id}</p>
            </div>

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Date</p>

              <p className="mb-0">{selectedPayment.date}</p>
            </div>

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Order Number</p>

              <p className="mb-0">{selectedPayment.order_number}</p>
            </div>

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Quantity of Item</p>

              <p className="mb-0">{selectedPayment?.order_item?.quantity}</p>
            </div>

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Unite Price</p>

              <p className="mb-0">₦{selectedPayment.unit_price}</p>
            </div>
          </div>

          <div className="spaceBetween hasBorder--bottom pt-2 pb-2">
            <p className="mb-0">Product Total</p>

            <p className="mb-0">₦{selectedPayment.product_cost}</p>
          </div>

          <div className="spaceBetween pt-2 pb-2">
            <p className="mb-0">Handing Cost</p>

            <p className="mb-0">₦{selectedPayment.handling_cost}</p>
          </div>

          <div className="spaceBetween hasBorder--bottom pt-2 pb-2">
            <p className="mb-0">Delivery Cost</p>

            <p className="mb-0">₦{selectedPayment.delivery_cost}</p>
          </div>

          <div className="spaceBetween hasBorder--bottom pt-2 pb-2">
            <p className="mb-0">Total Cost</p>

            <p className="mb-0">₦{selectedPayment.sub_total}</p>
          </div>
        </div>
      </Modal>

      <ConfirmModal
        show={confirm.modal}
        payment={confirm.payment}
        status={confirm.status}
        handleClose={() => {
          setConfirm({
            ...confirm,
            modal: false,
          });
        }}
      />
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  supplier_payments: state.admin.supplier_payments,
});

const mapDispatchToProps = (dispatch) => ({
  getPayments: (token, status, success) =>
    dispatch(get_customer_payments(token, status, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payments);
